/**
 * Created by Angelika on 07.09.2017.
 */
export const TOKEN_WRONG = "Access token wrong or expired";
export const VALIDATION_LOGIN_ERROR = 'Login and password are required.';
export const SERVER_NO_ANSWER = "Server doesn't answer";
export const VIDEO_FORMAT_UNDEFINED = 'Video format is undefined';

export const MEDIA_ERR_ABORTED = 1;
export const MEDIA_ERR_NETWORK = 'HLS playlist request error or network failed';
export const MEDIA_ERR_DECODE = 3;
export const MEDIA_ERR_SRC_NOT_SUPPORTED = 'The media could not be loaded, server or network failed or format is not supported.';
export const MEDIA_ERR_ENCRYPTED = 5;


// WEBPACK FOOTER //
// ./src/constants/errors.js